import ReviewRx from "./ReviewRx";

export default ReviewRx;
